import React from 'react'
import ProfileImage from '../ProfileImage/ProfileImage'
import './ErrorScreen.scss'

// Try Again: caller's onRetry, otherwise go back to the page that failed
const retry = (props: any) => {
    if (props?.onRetry) return props.onRetry();
    if (window.history.length > 1) window.history.back();
    else window.location.reload();
}

const ErrorScreen = (props: any) => (
    <div className='err' role='alert'>
        <div className='errLogo'>
            <ProfileImage color='rgba(255, 10, 10, 0.1)' />
        </div>
        <h1 className='errHeading'>An Error Occurred</h1>
        <p className='errInfo'>Sorry! We are facing technical issues.</p>
        <button type='button' className='errLink' onClick={() => retry(props)}>Try Again</button>
    </div>
)

export default ErrorScreen
